export const prepareBuildings = (buildings) => {
  if (buildings.length === 0) return []
  return buildings.map((building) => ({
    id: building.id,
    text: building.name,
  }))
}

export const getLocationId = (editUrl) => {
  let url = new URL(editUrl)
  let pathArray = url.pathname.split('/')
  return pathArray[pathArray.length - 1]
}

export const isValidLocationName = (value) => {
  const pattern = /^[A-Za-z0-9 -]+$/
  return pattern.test(value)
}
